import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {FunctionalScopeResource} from '@/common/api/api-raw-types';
import {urlService} from 'vue3-starter/dist/http/UrlService';

export default class FunctionalSkillsRepository {
    async loadScopes(): Promise<HttpServiceResponse<FunctionalScopeResource[]>> {
        return context.httpService.get(context.registry.entries.allFunctionalScopes());
    }

    async listFunctionalScopesByCategory(jobCategory: string): Promise<HttpServiceResponse<FunctionalScopeResource[]>> {
        const url = `${urlService.buildUrl(context.registry.entries.listFunctionalScopesByCategory(), jobCategory)}`;
        return context.httpService.get(url);
    }
}
